export default __webpack_public_path__ + "static/media/logo.7354c25d.svg";